<!--<template>-->
    <!--<pdf src="./assets/pdf/bt-toan-5-tap-2.pdf"></pdf>-->
<!--</template>-->

<template>
        <div class="container-fluid">
            <div class="row content-main-test">
                <div class="nav-left-list" v-show="false">
                    <p>Mục lục</p>
                    <hr width="85%">
                    <div class="ebook-left">

                    </div>
                </div>
                <!-- test -->
                <div class="content-test mt-4 content-ebook">
                    <div class="chevron-next">
                        <a @click="prev" href="#" role="button" data-slide="prev">
                            <i class="fa fa-chevron-left"></i>
                        </a>
                    </div>
                    <div>
                        <pdf
                                v-if="show"
                                ref="myPdfComponent"
                                :src="src"
                                :page="page"
                                @num-pages="numPages = $event"
                                style="width:100%"
                                @password="password"
                        ></pdf>
                        <div id="text-layer"></div>
                    </div>
                    <div class="chevron-next">
                        <a @click="next" href="#" role="button" data-slide="next">
                            <i class="fa fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div id="footer-pate42">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 list-exam">
                            <button id="danhsach" class="btn btn-primary" type="button">

                                <span><i class="fa fa-bars"></i> Mục lục</span>
                            </button>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 next-footer-ebook">
                            <div id="next-page-ebook">
                                <!--<a href="javascript:void(0)" @click="luyenTap" v-show="id==115" class="word active">Luyện tập</a>-->
                                <button @click="first">
                                    <i class="fa fa-backward"></i>
                                </button>
                                <button @click="prev">
                                    <i class="fa fa-caret-left"></i>

                                </button>
                                <input type="text" :value="(page-2>0?page-2:0)" disabled="disabled">
                                <button @click="next">
                                    <i class="fa fa-caret-right"></i>
                                </button>
                                <button @click="last">
                                    <i class="fa fa-forward"></i>
                                </button>
                            </div>
                            <div id="zoom-ebook">
                                <button @click="changeZoomLevel(-1)">-</button>
                                <input type="text" :value="zoom" v-on:keyup.enter="trySetNewZoom">
                                <button @click="changeZoomLevel(1)">+</button>
                            </div>
                            <button id="zoom-ebook-full"><i class="fa fa-expand"></i></button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
    import pdf from 'vue-pdf'
    //var loadingTask = pdf.createLoadingTask('http://localhost:3000/bt-toan-5-tap-hai-protected.pdf',{onPassword: "password"});
    export default {
        name: 'PdfViewerComp',
        components: {
            pdf
        },
        props:{
          bookName:''
        },
        data() {
            return {
                show: true,
                page: 1,
                src: 'http://localhost:8011/bt-toan-5-tap-hai-protected.pdf',
                size: {
                    width: -1,
                    height: -1
                },
                numPages:0,
                pdfDoc: null,
                zoom: 50
            }
        },
        mounted() {
           // console.log(this.pdfUrl("bt-toan-5-tap-2"))
//            this.src.then(pdf => {
//                    this.numPages = pdf.numPages;
//                    this.showPage(pdf);
//            });
            //this.showPage();
            //this.showPDF("http://localhost:8011/bt-toan-5-tap-2.pdf");
        },
        methods: {
            password: function(updatePassword, reason) {
                updatePassword("123456Aa@")
                //updatePassword(prompt('password is "123456Aa@"'));
            },
//            pageLoaded:function(number){
//                console.log("pageLoaded " + number)
//                console.log(this.$refs.myPdfComponent.pdf)
//               //this.showPage();
//            },
            showPage(){
                this.$refs.myPdfComponent.pdf.loadPage(this.page).then(function(page){
                    var viewport = page.getViewport(1);
                    // console.log("vao viewport");
                    // console.log(viewport);
                });
            },
            logContent() {
                var i = 0;
                var currentPage =this.page;
                this.$refs.myPdfComponent.pdf.forEachPage(function(page) {
                    i++;
                    if(i==currentPage) {
                        return page.getTextContent()
                                .then(function (content) {

                                    var text = content.items.map(item => item.str
                                    )
                                    ;
                                    // console.log(text);
                                })
                    }
                });
            },
            pdfUrl(name)
            {
                return "";// require(`@/assets/pdf/${name}.pdf`);
            },
            prev(){
                if(this.page>1){
                    this.page=this.page-1;
                }
            },
            next(){
                //console.log(this.$refs.myPdfComponent.pdf)
                if(this.page<this.numPages){
                    this.page=this.page+1;
                    this.logContent();
                }
            },
            first(){
                this.page=1;
            },
            last(){
                this.page=this.numPages;
            },
            changeZoomLevel(){

            },
            showPDF(pdf_url) {

                pdfJS.getDocument({ url: pdf_url }).then(function(pdf_doc) {
                    // console.log(pdf_doc)
                }).catch(function(error) {
                    // console.log(error);
                });;
            }
        }
    }
</script>
<style>
    /* resize-sensor.vue */
    @keyframes resizeSensorVisibility {
        from { top: 0; }
    }

    /* pdf.vue */
    .annotationLayer {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
    .annotationLayer section {
        position: absolute;
    }
    .annotationLayer .linkAnnotation > a {
        position: absolute;
        font-size: 1em;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .annotationLayer .linkAnnotation > a /* -ms-a */  {
        background: url("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7") 0 0 repeat;
    }
    .annotationLayer .linkAnnotation > a:hover {
        opacity: 0.2;
        background: #ff0;
        box-shadow: 0px 2px 10px #ff0;
    }
    .annotationLayer .textAnnotation img {
        position: absolute;
        cursor: pointer;
    }
    .annotationLayer .textWidgetAnnotation input,
    .annotationLayer .textWidgetAnnotation textarea,
    .annotationLayer .choiceWidgetAnnotation select,
    .annotationLayer .buttonWidgetAnnotation.checkBox input,
    .annotationLayer .buttonWidgetAnnotation.radioButton input {
        background-color: rgba(0, 54, 255, 0.13);
        border: 1px solid transparent;
        box-sizing: border-box;
        font-size: 9px;
        height: 100%;
        padding: 0 3px;
        vertical-align: top;
        width: 100%;
    }
    .annotationLayer .textWidgetAnnotation textarea {
        font: message-box;
        font-size: 9px;
        resize: none;
    }
    .annotationLayer .textWidgetAnnotation input[disabled],
    .annotationLayer .textWidgetAnnotation textarea[disabled],
    .annotationLayer .choiceWidgetAnnotation select[disabled],
    .annotationLayer .buttonWidgetAnnotation.checkBox input[disabled],
    .annotationLayer .buttonWidgetAnnotation.radioButton input[disabled] {
        background: none;
        border: 1px solid transparent;
        cursor: not-allowed;
    }
    .annotationLayer .textWidgetAnnotation input:hover,
    .annotationLayer .textWidgetAnnotation textarea:hover,
    .annotationLayer .choiceWidgetAnnotation select:hover,
    .annotationLayer .buttonWidgetAnnotation.checkBox input:hover,
    .annotationLayer .buttonWidgetAnnotation.radioButton input:hover {
        border: 1px solid #000;
    }
    .annotationLayer .textWidgetAnnotation input:focus,
    .annotationLayer .textWidgetAnnotation textarea:focus,
    .annotationLayer .choiceWidgetAnnotation select:focus {
        background: none;
        border: 1px solid transparent;
    }
    .annotationLayer .textWidgetAnnotation input.comb {
        font-family: monospace;
        padding-left: 2px;
        padding-right: 0;
    }
    .annotationLayer .textWidgetAnnotation input.comb:focus {
        /*
         * Letter spacing is placed on the right side of each character. Hence, the
         * letter spacing of the last character may be placed outside the visible
         * area, causing horizontal scrolling. We avoid this by extending the width
         * when the element has focus and revert this when it loses focus.
         */
        width: 115%;
    }
    .annotationLayer .buttonWidgetAnnotation.checkBox input,
    .annotationLayer .buttonWidgetAnnotation.radioButton input {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        appearance: none;
    }
    .annotationLayer .popupWrapper {
        position: absolute;
        width: 20em;
    }
    .annotationLayer .popup {
        position: absolute;
        z-index: 200;
        max-width: 20em;
        background-color: #FFFF99;
        box-shadow: 0px 2px 5px #333;
        border-radius: 2px;
        padding: 0.6em;
        margin-left: 5px;
        cursor: pointer;
        word-wrap: break-word;
    }
    .annotationLayer .popup h1 {
        font-size: 1em;
        border-bottom: 1px solid #000000;
        padding-bottom: 0.2em;
    }
    .annotationLayer .popup p {
        padding-top: 0.2em;
    }
    .annotationLayer .highlightAnnotation,
    .annotationLayer .underlineAnnotation,
    .annotationLayer .squigglyAnnotation,
    .annotationLayer .strikeoutAnnotation,
    .annotationLayer .lineAnnotation svg line,
    .annotationLayer .fileAttachmentAnnotation {
        cursor: pointer;
    }

</style>